import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import {
  WEEKLY_MEETINGS_LIST,
  MEETING_EDIT,
  MEETING_UPDATE,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
  MEETING_SCHEDULES_REGISTRY,
  MEETING_SCHEDULES_REGISTRY_STATUS_UPDATE,
  MEETING_FEES_REGISTRY,
  MEETING_FEES_REGISTRY_STATUS_UPDATE,
} from "../../routes/routes";
import { NoDataFound, checkEmptyOrNull, hasRole } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import { MEETING_UPDATED } from "../../constant/constant";
import { FullPageLoader } from "../../components/common/Loader"; // Import the loader component
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Modal } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { ValidationMessage } from "../../components/Utils";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

const WeeklyMeetingsList = () => {
  // ## State Variable Declaration
  const navigate = useNavigate();
  const { hasPermission } = usePermission();
  const [meetings, setMeetings] = useState([]);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [filter, setFilter] = useState([]);
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [schedulesRegistryModal, setSchedulesRegistryModal] = useState(false);
  const [feesRegistryModal, setFeesRegistryModal] = useState(false);
  const [schedulesRegistryData, setSchedulesRegistryData] = useState({});
  const [feesRegistryData, setFeesRegistryData] = useState({});

  // Event handler for dates set
  const handleDatesSet = (dateInfo) => {
    const { start, end } = dateInfo;
    const from_date = moment(start).format("YYYY-MM-DD");
    const to_date = moment(end).format("YYYY-MM-DD");
    setFilter({ ...filter, from_date: from_date, to_date: to_date });
  };

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const fetchMeetingData = async (id) => {
    try {
      axios.get(MEETING_EDIT + id).then((res) => {
        if (res.status === 200 && res.data.success) {
          let responseData = res.data.data;
          setDetailModal(true);
          setDetailData({
            id: responseData?.id,
            region_name: responseData?.region_name,
            chapter_name: responseData?.chapter_name,
            meeting_date: moment(
              responseData?.meeting_date,
              "DD/MM/YYYY",
            ).format("YYYY-MM-DD"),
            meeting_time: moment(responseData?.meeting_time, "hh:mm a").format(
              "HH:mm:ss",
            ),
          });
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;

  const fetchMeetingSchedulesRegistryData = async (id) => {
    try {
      axios
        .get(MEETING_SCHEDULES_REGISTRY + id + "/list")
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            let responseData = res.data.data.registrys;
            setSchedulesRegistryData(responseData);
          }
        })
        .finally(() => {
          setLoading(false); // Set loading to false after data is fetched
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateMeeting = (meetingId) => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...detailData };
    axios
      .put(MEETING_UPDATE + meetingId, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setDetailModal(false);
          toast.success(MEETING_UPDATED, {
            onClose: () => window.location.reload(),
          });
          navigate("/weekly-meetings");
        }
      })
      .catch((err) => {
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        } else {
          toast.error(err.response?.data?.msg || "Something went wrong");
        }
      })
      .finally(() => {
        setRefresh(true);
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  const updateMeetingSchedulesRegistryStatus = async (
    meetingId,
    registryId,
    status,
  ) => {
    axios
      .post(MEETING_SCHEDULES_REGISTRY_STATUS_UPDATE + registryId, {
        status: status,
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          fetchMeetingSchedulesRegistryData(meetingId);
        }
      })
      .catch((err) => {
        toast.error(err.response.data.msg);
      });
  };

  const fetchMeetingFeesRegistryData = async (id) => {
    try {
      axios
        .get(MEETING_FEES_REGISTRY + id + "/list")
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            let responseData = res.data.data.registrys;
            setFeesRegistryData(responseData);
          }
        })
        .finally(() => {
          setLoading(false); // Set loading to false after data is fetched
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateMeetingFeesRegistryStatus = async (
    eventId,
    registryId,
    status,
  ) => {
    axios
      .post(MEETING_FEES_REGISTRY_STATUS_UPDATE + registryId, {
        status: status,
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          fetchMeetingFeesRegistryData(eventId);
        }
      });
  };

  useEffect(() => {
    try {
      axios
        .get(WEEKLY_MEETINGS_LIST, {
          params: {
            isAdmin: 1,
            ...filter,
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setMeetings(response.data.data.meetings);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [refresh, filter]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Weekly Meetings</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">
                    Weekly Meetings List
                  </span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard">
          <div className="container-fluid f_containter">
            <div className="row mb-4">
              {hasRole([1]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="mb-3 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      ref={selectRegionRef}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="chapter_id">
                      Chapter
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) =>
                        setFilter({ ...filter, chapter_id: selected?.value })
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {meetings.length > 0 && (
            <div className="d-flex flex-wrap gap-3 mb-3 px-1 align-items-center">
              {Array.from(
                new Map(
                  meetings
                    .filter((m) => m.backgroundColor)
                    .map((m) => [
                      m.chapter_name,
                      { bg: m.backgroundColor, text: m.textColor },
                    ])
                ).entries()
              ).map(([chapter, colors], idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center gap-2"
                  style={{ fontSize: "14px", color: "#566a7f", fontWeight: 500 }}
                >
                  <span
                    style={{
                      width: "12px",
                      height: "12px",
                      backgroundColor: colors.bg,
                      borderRadius: "3px",
                      display: "inline-block"
                    }}
                  ></span>
                  <span>{chapter}</span>
                </div>
              ))}
            </div>
          )}

          <div className="table-responsive text-nowrap">
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "prev,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
              }}
              firstDay="1"
              displayEventTime={false}
              allDaySlot={false}
              defaultView="month"
              initialView="dayGridMonth"
              themeSystem="bootstrap"
              events={meetings}
              eventDidMount={(info) => {
                // console.log(info.event);
                info.el.style.backgroundColor = info.event.backgroundColor;
                info.el.style.borderColor = info.event.borderColor;
                info.el.style.color = info.event.textColor;
              }}
              editable={false}
              defaultTimedEventDuration="02:00:00" // Set the default duration to 2 hour
              // eventClick={(event) => {
              //   fetchMeetingData(event.event.id);
              // }}
              eventContent={(eventContent) => (
                <>
                  <div>{eventContent.event.title}</div>
                  {hasPermission("weekly-attendance-edit") &&
                    eventContent.event.extendedProps.meeting_status === 0 && (
                      <button
                        className="badge bg-label-info1 me-2 border-0 pad-4 mt-2"
                        data-bs-toggle="tooltip"
                        data-bs-offset="0,4"
                        data-bs-placement="top"
                        data-bs-html="true"
                        title="Edit Meeting Date & Time"
                        data-bs-original-title="Edit Meeting Date & Time"
                        onClick={() => {
                          fetchMeetingData(eventContent.event.id);
                        }}
                      >
                        <i className="bx bx-pencil"></i>
                      </button>
                    )}

                  {hasPermission("weekly-attendance-edit") && (
                    <button
                      className="badge bg-label-success1 me-2 border-0 pad-4 mt-2"
                      data-bs-toggle="tooltip"
                      data-bs-offset="0,4"
                      data-bs-placement="top"
                      data-bs-html="true"
                      title="Attendance Registry"
                      data-bs-original-title="Attendance Registry"
                      onClick={() => {
                        setSchedulesRegistryModal(true);
                        fetchMeetingSchedulesRegistryData(
                          eventContent.event.id,
                        );
                      }}
                    >
                      <i className="bx bx-user-check"></i>
                    </button>
                  )}
                </>
              )}
              datesSet={handleDatesSet}
            />
          </div>
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#019342"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <div className="d-flex flex-column w-100">
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="modal_title1"
            >
              Meeting Details ({detailData?.region_name} -{" "}
              {detailData?.chapter_name})
            </Modal.Title>
            <div className="d-flex gap-3 mt-1" style={{ fontSize: "0.85rem" }}>
              <div className="d-flex align-items-center gap-1">
                <i className="bx bx-calendar text-primary"></i>
                <strong>Date:</strong>&nbsp;
                {detailData?.meeting_date
                  ? moment(detailData?.meeting_date).format("DD-MM-YYYY")
                  : ""}
              </div>
              <div className="d-flex align-items-center gap-1">
                <i className="bx bx-time text-primary"></i>
                <strong>Time:</strong>&nbsp;
                {detailData?.meeting_time
                  ? moment(detailData?.meeting_time, "HH:mm:ss").format(
                      "hh:mm A",
                    )
                  : ""}
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              {/* <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_region">
                    Region<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readonly="true"
                    disabled="true"
                    className="form-control hide-arrow"
                    defaultValue={detailData?.region_name}
                    style={{ background: "#eee", cursor: "not-allowed" }}
                  />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_chapter">
                    Chapter<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    readonly="true"
                    disabled="true"
                    className="form-control hide-arrow"
                    defaultValue={detailData?.chapter_name}
                    style={{ background: "#eee", cursor: "not-allowed" }}
                  />
                </div>
              </div> */}

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_date">
                    Meeting Date<span className="text-danger">*</span>
                  </label>
                  <Flatpickr
                    className="form-control"
                    options={{
                      dateFormat: "Y-m-d",
                      enableTime: false,
                      minDate: "today",
                      onChange: (selected) =>
                        setDetailData({
                          ...detailData,
                          meeting_date: moment(selected[0]).format(
                            "YYYY-MM-DD",
                          ),
                        }),
                    }}
                    value={detailData?.meeting_date}
                    placeholder="Select Event Date"
                  />
                  <ValidationMessage error={errors} name="meeting_date" />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="meeting_time">
                    Meeting Time<span className="text-danger">*</span>
                  </label>
                  <Flatpickr
                    className="form-control"
                    options={{
                      dateFormat: "H:i",
                      time_24hr: true,
                      enableTime: true,
                      noCalendar: true,
                      onChange: (selected) =>
                        setDetailData({
                          ...detailData,
                          meeting_time: moment(selected[0]).format("HH:mm:ss"),
                        }),
                    }}
                    value={detailData?.meeting_time}
                    placeholder="Select From Time"
                  />
                  <ValidationMessage error={errors} name="from_time" />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-success isubmit_button"
            data-bs-dismiss="modal"
            onClick={() => updateMeeting(detailData?.id)}
          >
            Update
          </button>
          <button
            type="button"
            className="btn btn-primary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={schedulesRegistryModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setSchedulesRegistryModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <div className="d-flex flex-column w-100">
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="modal_title1"
            >
              Meeting Attendance Details
            </Modal.Title>
            <div className="d-flex gap-3 mt-1" style={{ fontSize: "0.85rem" }}>
              <div className="d-flex align-items-center gap-1">
                <i className="bx bx-calendar text-primary"></i>
                <strong>Date:</strong>&nbsp;
                {schedulesRegistryData[0]?.meeting_date}
              </div>
              <div className="d-flex align-items-center gap-1">
                <i className="bx bx-time text-primary"></i>
                <strong>Time:</strong>&nbsp;
                {schedulesRegistryData[0]?.meeting_time}
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th style={{ textAlign: "center", width: "10%" }}>Sl. No.</th>
                  <th style={{ textAlign: "center", width: "60%" }}>Member</th>
                  <th style={{ textAlign: "center", width: "30%" }}>
                    Attended Status
                  </th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="3" />
                ) : schedulesRegistryData.length > 0 ? (
                  schedulesRegistryData.map((registry, i) => (
                    <tr key={i}>
                      <td>{registry?.sno}</td>
                      <td
                        style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                      >
                        <span className="table_img pr-2">
                          <img src={registry?.user_profile_image} alt="icon" />
                        </span>
                        {registry?.user_name}
                      </td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${i}`}
                          value="1"
                          checked={
                            registry?.meeting_status === 1 ? true : false
                          }
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 2;
                            updateMeetingSchedulesRegistryStatus(
                              registry?.meeting_id,
                              registry?.id,
                              statusVal,
                            );
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="3" message="No Data Found" />
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setSchedulesRegistryModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={feesRegistryModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setFeesRegistryModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Meeting Fees Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th style={{ textAlign: "center", width: "10%" }}>Sl. No.</th>
                  <th style={{ textAlign: "center", width: "60%" }}>User</th>
                  <th style={{ textAlign: "center", width: "30%" }}>
                    Payment Status
                  </th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="3" />
                ) : feesRegistryData.length > 0 ? (
                  feesRegistryData.map((registry, i) => (
                    <tr key={i}>
                      <td>{registry?.sno}</td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={registry?.user_profile_image} alt="icon" />
                        </span>
                        {registry?.user_name}
                      </td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${i}`}
                          value="1"
                          checked={
                            registry?.payment_status === 1 ? true : false
                          }
                          label=""
                          onChange={(event) => {
                            const statusVal = event.target.checked ? 1 : 0;
                            updateMeetingFeesRegistryStatus(
                              registry?.meeting_id,
                              registry?.id,
                              statusVal,
                            );
                          }}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="3" message="No Data Found" />
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setFeesRegistryModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WeeklyMeetingsList;
